import { Pipe, PipeTransform, inject } from '@angular/core'
import { TimezoneOption } from 'projects/commons/src/lib/types/timezone'
import { LocaleService } from 'projects/commons/src/lib/services/locale.service'

@Pipe({
  name: 'cycDate',
})
export class CycDatePipe implements PipeTransform {
  private localeSvc = inject(LocaleService)

  transform(
    value: string | Date | number,
    timezone = 'UTC',
    timezoneOption: TimezoneOption = 'UTC',
    includeYear = false,
  ): string {
    const displayTimezone =
      timezoneOption === 'PLANT' && timezone ? timezone : 'UTC'

    const dt = new Date(value)

    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      timeZone: displayTimezone,
    }
    if (includeYear) {
      options['year'] = 'numeric'
    }
    const formatted = new Intl.DateTimeFormat(
      this.localeSvc.selectedLocale(),
      options,
    ).format(dt)
    return formatted
  }
}
